import "./App.css";

import * as routes from "./constants/routes";

/* Library components */
import { Link, Route, Router } from "react-router-dom";
import React, { Component } from "react";

/* Services */
import AuthService from "./services/auth";
import ChatConversations from "./components/chat-conversations";
import ChatDrawer from "./components/ChatDrawer";
import EmailActivation from "./components/EmailActivation";
import Forgot from "./components/Forgot";
import HomePage from "./pages/home";
import Intercom from "react-intercom";
import Last2Weeks from "./components/Last2WeeksUsers";
import Login from "./components/Login";
import Messages from "./components/messages";
/* Pages */
import Profile from "./pages/profile";
import PromoCodeRequests from "./components/PromoCodeRequests";
import RegistrationForm from "./components/RegistrationForm";
import ResetPassword from "./components/ResetPassword";
import Settings from "./pages/settings";
import SubscriptionModal from "./components/SubscriptionModal";
import USER_STATUSES from "./constants/userStatuses";
import UnapprovedProfileList from "./components/UnapprovedProfileList";
import chevron from "./static/vectors/chevron.svg";
import chevronWhite from "./static/vectors/chevron-white.svg";
import { compose } from "recompose";
/* Constants */
import config from "./config";
import { connect } from "react-redux";
import createHistory from "history/createBrowserHistory";
import { db } from "./firebase";
import facebook from "./static/vectors/facebook.svg";
import flirts from "./pages/flirts";
import gem from "./static/vectors/gem.svg";
import gemBlack from "./static/vectors/gem-black.svg";
import gemRed from "./static/vectors/gem-red.svg";
import heart from "./static/vectors/heart-solid.svg";
import home from "./static/vectors/home.svg";
import instagram from "./static/vectors/instagram.svg";
/* Assets */
import logo from "./static/images/upperclass-icon-only.png";
import magnet from "./pages/magnets";
import magnetBlack from "./static/vectors/magnet-black.svg";
import magnetIcon from "./static/vectors/magnet.svg";
import message from "./static/vectors/message.svg";
/* Components */
import messages from "./components/messages";
import moment from "moment";
import promoUpgrade from "./pages/promoUpgrade";
import publicProfile from "./pages/publicProfile";
import reactGA from "react-ga";
import search from "./pages/search";
import searchIcon from "./static/vectors/search.svg";
import subscribeSugarBaby from "./pages/subscribeSugarBaby";
import upgrade from "./pages/upgrade";
import withAuth from "./components/withAuth";

if (config.useAnalytics) {
  reactGA.initialize(config.analyticsCode);
}
const history = createHistory();
history.listen(location => {
  reactGA.set({ page: location.pathname });
  reactGA.pageview(location.pathname);
});

class App extends Component {
  constructor(props) {
    super(props);
    document.title = "UpperClassDates";

    document.addEventListener("click", e => {
      if (!e.target.className.includes("popup-toggler")) {
        if (this.props.settingPopupVisible) {
          this.props.onSettingPopupToggle(false);
        }
      }
    });

    window.addEventListener("resize", () => {
      if (this.props.openChatDrawer) {
        if (window.innerWidth < 768) {
          document.body.className += " no-scroll ";
        } else {
          let elClass = " " + document.body.className + " ";
          while (elClass.indexOf(" no-scroll ") !== -1) {
            elClass = elClass.replace(" no-scroll ", "");
          }
          document.body.className = elClass;
        }
      }
    });
  }

  componentWillReceiveProps(props) {
    if (props.openChatDrawer) {
      if (window.innerWidth < 768) {
        document.body.className += " no-scroll ";
      } else {
        let elClass = " " + document.body.className + " ";
        while (elClass.indexOf(" no-scroll ") !== -1) {
          elClass = elClass.replace(" no-scroll ", "");
        }
        document.body.className = elClass;
      }
    } else {
      let elClass = " " + document.body.className + " ";
      while (elClass.indexOf(" no-scroll ") !== -1) {
        elClass = elClass.replace(" no-scroll ", "");
      }
      document.body.className = elClass;
    }

    const { ucdUser, onSetUnreadCount } = props;

    if (ucdUser !== null) {
      db.userUnread(ucdUser.id).on("value", snap => {
        const unreadCount =
          snap.val() !== null ? Object.keys(snap.val()).length : 0;
        onSetUnreadCount(unreadCount);
      });
    }
  }

  componentWillMount() {
    this.width = window.innerWidth;
  }

  toggleSettingPopup(e) {
    const { onSettingPopupToggle, settingPopupVisible } = this.props;
    e.preventDefault();
    onSettingPopupToggle(!settingPopupVisible);
  }

  toggleChatDrawer() {
    const { onChatDrawerOpen, openChatDrawer } = this.props;
    onChatDrawerOpen(!openChatDrawer, false);
  }

  setRoom(room, user) {
    const { onChatRoomSelected } = this.props;
    onChatRoomSelected(room, user);
  }

  logOut(e) {
    const { onSettingPopupToggle } = this.props;
    AuthService.logOut(e);
    onSettingPopupToggle(false);
  }

  render() {
    const {
      ucdUser: user,
      settingPopupVisible,
      openChatDrawer,
      openRoom,
      chatUser,
      unreadCount,
      currentPage
    } = this.props;

    const intercomUser =
      user !== null
        ? { user_id: user.id, name: user.name, email: user.email }
        : {};
    const profilePhoto =
      user !== null && user.photos.length > 0
        ? user.photos.filter(el => el.profile === 1).pop()
        : { photoUrl: "" };
    return (
      <Router history={history}>
        <div className="App">
          <header className="App-header">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col">
                  <Link className="homepage" to="/">
                    <img src={logo} className="App-logo" alt="logo" />
                    <span
                      className={`home-link d-none d-lg-inline-block ${
                        currentPage === routes.HOME ? "active" : ""
                      }`}
                    >
                      <img
                        src={home}
                        className="home-icon d-none d-lg-inline-block"
                        alt="home"
                      />
                      Featured
                    </span>
                  </Link>
                  {AuthService.isLoggedIn() &&
                    (user !== null &&
                      user.status >= USER_STATUSES.approved) && (
                      <Link
                        to={routes.SEARCH}
                        className={`home-link ${
                          currentPage === routes.SEARCH ? "active" : ""
                        }`}
                      >
                        <img
                          src={searchIcon}
                          className="home-icon"
                          alt="search"
                        />
                        <span className="d-none d-lg-inline-block">Search</span>
                      </Link>
                    )}
                  {AuthService.isLoggedIn() &&
                    (user !== null &&
                      user.status >= USER_STATUSES.approved) && (
                      <button
                        className={`has-popup home-link`}
                        data-unread={unreadCount}
                        onClick={() => {
                          this.toggleChatDrawer();
                        }}
                      >
                        <img
                          src={message}
                          className="home-icon"
                          alt="message"
                        />
                        <span className="d-none d-lg-inline-block">
                          Messages
                        </span>
                      </button>
                    )}
                  {AuthService.isLoggedIn() && (
                    <Link
                      to={routes.FLIRTS}
                      className={`has-popup home-link ${
                        currentPage === routes.FLIRTS ? "active" : ""
                      }`}
                      data-unread={
                        user === null ? 0 : user.isFavouritedBy.length
                      }
                    >
                      <img src={heart} className="home-icon" alt="heart" />
                      <span className="d-none d-lg-inline-block">Flirts</span>
                    </Link>
                  )}
                </div>
                {!AuthService.isLoggedIn() && (
                  <div className="col">
                    <ul className="nav justify-content-end">
                      <li className="nav-item">
                        <Link to="/login">login</Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/join">join</Link>
                      </li>
                    </ul>
                  </div>
                )}
                {AuthService.isLoggedIn() && (
                  <div className="col col-auto text-right">
                    <Link
                      to={
                        user !== null && user.magnetCount > 0
                          ? routes.SETTING_MAGNET
                          : routes.MAGNET
                      }
                      className="d-none d-lg-inline-block has-popup home-link"
                      data-unread={user === null ? 0 : user.magnetCount}
                    >
                      <img
                        src={magnetIcon}
                        className="home-icon magnet"
                        alt="magnet"
                      />
                      <span className="d-none d-xl-inline-block">magnet</span>
                    </Link>
                    {user !== null &&
                      user.status > USER_STATUSES.confirmed &&
                      user.accountType === "sugar_parent" && (
                        <div
                          className={`d-none d-lg-inline-block home-link ${
                            user !== null &&
                            user.status === USER_STATUSES.superior
                              ? "red"
                              : ""
                          }`}
                        >
                          <Link to={routes.UPGRADE}>
                            <img
                              src={
                                user !== null &&
                                user.status === USER_STATUSES.superior
                                  ? gemRed
                                  : gem
                              }
                              className="home-icon"
                              alt="upgrade"
                            />
                            <span
                              className={`d-none d-xl-inline-block ${
                                user && user.status >= USER_STATUSES.superior
                                  ? "superior"
                                  : ""
                              }`}
                            >{`${
                              user && user.status >= USER_STATUSES.superior
                                ? "Date"
                                : "Upgrade"
                            }`}</span>
                          </Link>
                        </div>
                      )}
                    <img
                      src={profilePhoto.photoUrl}
                      onClick={e => {
                        this.toggleSettingPopup(e);
                      }}
                      className="popup-toggler profile-photo"
                      alt="Profile"
                    />
                    <img
                      src={chevronWhite}
                      onClick={e => {
                        this.toggleSettingPopup(e);
                      }}
                      className={`popup-toggler icon ${
                        settingPopupVisible ? "open" : ""
                      }`}
                      alt="chevron"
                    />
                    <ul
                      className={`nav popup justify-content-end ${
                        settingPopupVisible ? "d-block" : "d-none"
                      }`}
                    >
                      {user !== null &&
                        user.status > USER_STATUSES.confirmed &&
                        user.accountType === "sugar_parent" && (
                          <li className="d-block d-lg-none nav-item">
                            <Link
                              to={routes.UPGRADE}
                              className="home-link upgrade"
                            >
                              <img
                                src={
                                  user !== null &&
                                  user.status >= USER_STATUSES.superior
                                    ? gemRed
                                    : gemBlack
                                }
                                className="home-icon upgrade"
                                alt="upgrade"
                              />
                              {user !== null &&
                                user.status >= USER_STATUSES.superior && (
                                  <span className={"red"}>Superior</span>
                                )}
                              {user !== null &&
                                user.status < USER_STATUSES.superior && (
                                  <span>Upgrade</span>
                                )}
                            </Link>
                          </li>
                        )}
                      <li className="d-block d-lg-none nav-item">
                        <Link
                          to={
                            user !== null && user.magnetCount > 0
                              ? routes.SETTING_MAGNET
                              : routes.MAGNET
                          }
                          className="home-link"
                          data-unread={user === null ? 0 : user.magnetCount}
                        >
                          <img
                            src={magnetBlack}
                            className="home-icon magnet"
                            alt="magnet"
                          />
                          <span>{`${
                            user !== null && user.magnetCount > 0
                              ? user.magnetCount + "x magnet"
                              : "magnets"
                          }`}</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/profile/basic">Profile options</Link>
                        <img src={chevron} className="icon" alt="chevron" />
                      </li>
                      <li className="nav-item">
                        <Link to="/settings">Settings</Link>
                        <img src={chevron} className="icon" alt="chevron" />
                      </li>
                      <li className="nav-item">
                        <a href="/" onClick={e => this.logOut(e)}>
                          Log out
                        </a>
                        <img src={chevron} className="icon" alt="chevron" />
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </header>
          <Route exact path={routes.HOME} component={HomePage} />
          <Route path={routes.ACTIVATE} component={EmailActivation} />
          <Route path={routes.RESET_PASSWORD} component={ResetPassword} />
          <Route path={routes.LOGIN} component={Login} />
          <Route path={routes.FORGOT_PASSWORD} component={Forgot} />
          <Route path={routes.JOIN} component={RegistrationForm} />
          <Route path={routes.PROFILE} component={Profile} />
          <Route path={routes.SETTINGS} component={Settings} />
          <Route
            path={routes.APPROVE_USERS}
            component={UnapprovedProfileList}
          />
          <Route path={routes.LAST_2_WEEKS} component={Last2Weeks} />
          <Route
            path={routes.PROMO_CODE_REQUESTS}
            component={PromoCodeRequests}
          />
          <Route path={routes.MEMBER_PROFILE} component={publicProfile} />
          <Route path={routes.MESSAGES} component={messages} />
          <Route path={routes.SEARCH} component={search} />
          <Route path={routes.FLIRTS} component={flirts} />
          <Route path={routes.UPGRADE} component={upgrade} />
          <Route path={routes.PROMO_UPGRADE} component={promoUpgrade} />
          <Route path={routes.MAGNET} component={magnet} />
          <Route path={routes.SUBSCRIBE} component={subscribeSugarBaby} />

          {AuthService.isLoggedIn() && (
            <ChatDrawer className={openChatDrawer ? "visible" : ""}>
              {openRoom && (
                <Messages
                  room={openRoom}
                  user={chatUser}
                  onClose={() =>
                    this.setState({ openRoom: false, openChatDrawer: false })
                  }
                />
              )}
              {!openRoom && (
                <ChatConversations
                  onRoomSelected={(room, user) => {
                    this.setRoom(room, user);
                  }}
                />
              )}
            </ChatDrawer>
          )}
          <div
            className={`menu-backdrop ${openChatDrawer ? "visible" : ""}`}
            onClick={() => {
              this.toggleChatDrawer();
            }}
          />
          <footer>
            <div className="container">
              <div className="row social-media">
                <div className="col">
                  <div className="share">Follow us:</div>
                  <a
                    href="https://www.facebook.com/upperclassdates/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={facebook} alt="Share on Facebook" />
                  </a>
                  <a
                    href="https://www.instagram.com/upperclassdates/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={instagram} alt="Share on Instagram" />
                  </a>
                </div>
              </div>
              <div className="row links">
                <div className="col">
                  <a href="">blog</a>
                  <a href="https://upperclassdates.com/privacy-statement/">
                    privacy
                  </a>
                  <a
                    href="https://upperclassdates.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    terms
                  </a>
                  <a href="mailto:support@upperclassdates.com">support</a>
                </div>
              </div>
              <div className="row copy">
                <div className="col">
                  &copy; {moment().format("YYYY")}{" "}
                  <a href="/">Upperclassdates.com</a>
                </div>
              </div>
            </div>
          </footer>
          {currentPage !== routes.SUBSCRIBE && <SubscriptionModal />}
          <Intercom appID={config.intercomKey} {...intercomUser} />
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  settingPopupVisible: state.appState.settingPopupVisible,
  openChatDrawer: state.appState.openChatDrawer,
  openRoom: state.appState.openRoom,
  chatUser: state.appState.chatUser,
  ucdUser: state.sessionState.ucdUser,
  unreadCount: state.appState.unreadCount,
  currentPage: state.appState.currentPage
});

const mapDispatchToProps = dispatch => ({
  onSettingPopupToggle: settingPopupVisible =>
    dispatch({ type: "SET_SETTING_POPUP_VISIBLE", settingPopupVisible }),
  onChatDrawerOpen: (openChatDrawer, openRoom) =>
    dispatch({ type: "SET_OPEN_DRAWER", openChatDrawer, openRoom }),
  onChatRoomSelected: (openRoom, user) =>
    dispatch({
      type: "SET_OPEN_ROOM",
      openRoom,
      user,
      openChatDrawer: openRoom !== false
    }),
  onSetUnreadCount: count =>
    dispatch({ type: "SET_UNREAD_COUNT", unreadCount: count }),
  setCurrentPage: page => dispatch({ type: "SET_CURRENT_PAGE", page })
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withAuth
)(App);



// WEBPACK FOOTER //
// ./src/App.js